/**
 * Метод для получения ID - операторов из массива тур продуктов.
 */
export default (tourProducts) => {
    const operatorsIds = _.reduce(tourProducts, (acc, tourProduct) => {
        acc.push(tourProduct?.tour.get('operator').id);
        return acc;
    }, []);

    return _.uniq(operatorsIds);
};
